// src/components/About.js
import React, { useState } from 'react';

const About = () => {
  const [activeTab, setActiveTab] = useState('capabilities');

  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="about-col-1">
            {/* Replace this image with a SafeGam AI logo or relevant image */}
            <img src="images/safegam-1.png" alt="SafeGam AI" />
          </div>
          <div className="about-col-2">
            <h1 className="sub-title">About SafeGam AI</h1>
            <p>
              SafeGam AI is an advanced security and analytics platform designed to protect users in both the **gambling** and **blockchain** ecosystems.  
              <br /><br />
              SafeGam AI provides two core utilities:
              <ul>
                <li><strong>🛡️ Chrome Extension:</strong> An AI-powered tool that enhances gambling security by analyzing casino websites for scams, identifying slot patterns, and providing real-time betting insights.</li>
                <li><strong>🖥️ Web DApp Terminal:</strong> A blockchain-powered security platform where users can **scan smart contracts** for vulnerabilities and **request casino website security audits**.</li>
              </ul>
              <br />
              Whether you're a gambler looking for **safer play recommendations** or a blockchain user needing **smart contract security scans**, SafeGam AI provides an **all-in-one protection system**.  
            </p>

            <div className="tab-titles">
              <p
                className={`tab-links ${activeTab === 'capabilities' ? 'active-link' : ''}`}
                onClick={() => setActiveTab('capabilities')}
              >
                Key Capabilities
              </p>
              <p
                className={`tab-links ${activeTab === 'timeline' ? 'active-link' : ''}`}
                onClick={() => setActiveTab('timeline')}
              >
                Development Timeline
              </p>
              <p
                className={`tab-links ${activeTab === 'milestones' ? 'active-link' : ''}`}
                onClick={() => setActiveTab('milestones')}
              >
                Milestones
              </p>
            </div>

            {/* Key Capabilities */}
            <div
              className={`tab-contents ${activeTab === 'capabilities' ? 'active-tab' : ''}`}
              id="capabilities"
            >
              <ul>
                <li>
                  <span>🔍 Casino Security Analysis:</span><br />
                  AI scans online casinos for scam risks, trust levels, and security vulnerabilities.
                </li>
                <li>
                  <span>🎰 Slot AI Insights:</span><br />
                  Real-time slot machine analysis to detect "hot" & "cold" patterns.
                </li>
                <li>
                  <span>📜 Smart Contract Scanner:</span><br />
                  AI-powered vulnerability detection for blockchain smart contracts.
                </li>
                <li>
                  <span>📝 User-Requested Casino Audits:</span><br />
                  Users can request **AI-driven security audits** for new casinos.
                </li>
                <li>
                  <span>🛡️ Risk Assessment Engine:</span><br />
                  AI evaluates gambling sites and blockchain contracts for **security threats**.
                </li>
              </ul>
            </div>

            {/* Development Timeline */}
            <div
              className={`tab-contents ${activeTab === 'timeline' ? 'active-tab' : ''}`}
              id="timeline"
            >
              <ul>
                <li>
                  <span>2024 Q1:</span><br />
                  Initial development of SafeGam AI Chrome extension.
                </li>
                <li>
                  <span>2024 Q3:</span><br />
                  Launch of AI-powered **casino security scanner**.
                </li>
                <li>
                  <span>2025 Q1:</span><br />
                  Development of Web DApp Terminal for **smart contract analysis**.
                </li>
                <li>
                  <span>2025 Q3:</span><br />
                  User-requested **casino security audits** feature implemented.
                </li>
                <li>
                  <span>2026 Q1:</span><br />
                  Full integration of AI-powered security checks across gambling & blockchain.
                </li>
              </ul>
            </div>

            {/* Milestones */}
            <div
              className={`tab-contents ${activeTab === 'milestones' ? 'active-tab' : ''}`}
              id="milestones"
            >
              <ul>
                <li>
                  <span>🚀 SafeGam AI Chrome Extension Released:</span><br />
                  AI-powered gambling security scanner goes live.
                </li>
                <li>
                  <span>🔍 Smart Contract Scanner Integration:</span><br />
                  Blockchain vulnerability detection added to the platform.
                </li>
                <li>
                  <span>📊 User-Requested Casino Audits:</span><br />
                  First set of **casino security requests** processed.
                </li>
                <li>
                  <span>🤝 Strategic Partnerships:</span><br />
                  Collaboration with gambling security firms & blockchain projects.
                </li>
                <li>
                  <span>🏆 Community Growth:</span><br />
                  Expansion of SafeGam AI's **trusted network of security analysts**.
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
